import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    plain: "",
    size: "small",
    onClick: _ctx.scanPort
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CmSvgIcon, {
        class: "refresh-icon",
        name: "views/dashboard/manage/port-manage/_components/_images/refresh",
        monochrome: "",
        size: 19
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.t('portManage.refreshPortScan')), 1)
    ]),
    _: 1
  }, 8, ["onClick"]))
}